import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiFetch, ApiError } from '@/lib/api';
import { useToast } from '@/lib/toast';
import type { SendungCreateRequest } from '@/types/detail';

export function useCreateSendung(bestellnr: string) {
  const qc = useQueryClient();
  const toast = useToast();
  return useMutation({
    mutationFn: (body: SendungCreateRequest) =>
      apiFetch<{ sendung: { id: number; bestellung_id: number } }>(
        '/sendungen/create.php',
        { method: 'POST', body: JSON.stringify(body) }
      ),
    onSuccess: () => {
      toast('success', 'Sendung angelegt.');
      qc.invalidateQueries({ queryKey: ['bestellung', bestellnr] });
      qc.invalidateQueries({ queryKey: ['bestellungen'] });
    },
    onError: (err) => {
      const code = err instanceof ApiError ? err.code : 'unbekannt';
      if (code === 'versandart_required') {
        toast('error', 'Versandart fehlt — bitte wählen.');
      } else {
        toast('error', `Sendung fehlgeschlagen: ${code}`);
      }
    }
  });
}
